/**
 * UTB — Trustpilot rating + clickable stars
 * Mirror van assets/restore-probiotics-trustpilot.js + clickable-rating
 * uit assets/solvey-product-header.js, aangepast op utb-structuur:
 * de rating zit hier in `.product-rating` direct (geen `.product__rating-below-price`).
 *
 * Scope: enkel op /products/clear-out-patches-with-salicylic-acid.
 * Idempotent via dataset.solveyTrustInjected guard op de host.
 */
(function () {
  'use strict';
  if (!document.body.classList.contains('product-handle--clear-out-patches-with-salicylic-acid')) return;

  var HOST_SELECTOR = '.product__primary-right .product-rating';
  var GUARD_ATTR = 'data-solvey-trust-injected';
  var TRUSTPILOT_URL = 'https://nl.trustpilot.com/review/solveyfem.com';
  var SCORE_TEXT = '4,6/5 op';

  function findReviewsTarget() {
    var heads = document.querySelectorAll('h2, h3');
    for (var i = 0; i < heads.length; i++) {
      var t = heads[i].textContent.trim();
      if (/customers? tell it better|reviews|onze klanten|wat.*say|wat.*zeg/i.test(t)) {
        return heads[i].closest('.shopify-section, section') || heads[i];
      }
    }
    var slider = document.querySelector('[class*="testimonials-slider-wrapper"], [class*="testimonials-template"], [class*="ss-testimonial"]');
    if (slider) return slider.closest('.shopify-section') || slider;
    return document.querySelector('[class*="jdgm-rev-widg"], [id*="judgeme_product_reviews"]');
  }

  function makeClickable(rating) {
    if (!rating || rating.dataset.solveyClickable === '1') return;
    rating.dataset.solveyClickable = '1';
    rating.setAttribute('role', 'button');
    rating.setAttribute('tabindex', '0');
    rating.setAttribute('aria-label', 'Read customer reviews');
    rating.style.cursor = 'pointer';

    var go = function (e) {
      var target = findReviewsTarget();
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: top, behavior: 'smooth' });
    };
    rating.addEventListener('click', go);
    rating.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') go(e);
    });
  }

  function hideCount(rating) {
    var count = rating.querySelector('.product-rating__count');
    if (count) count.style.display = 'none';
  }

  function injectTrustpilot(rating) {
    if (rating.getAttribute(GUARD_ATTR) === '1') return;
    rating.setAttribute(GUARD_ATTR, '1');

    // Make rating a flex container so stars + trustpilot align
    rating.style.display = 'flex';
    rating.style.alignItems = 'center';
    rating.style.flexWrap = 'wrap';
    rating.style.gap = '10px';

    var link = document.createElement('a');
    link.href = TRUSTPILOT_URL;
    link.target = '_blank';
    link.rel = 'noopener';
    link.className = 'solvey-trustpilot-mention';
    link.setAttribute('aria-label', '4,6 van 5 op Trustpilot — opent in nieuw tabblad');
    link.innerHTML = '<span class="solvey-trustpilot-text">' + SCORE_TEXT + ' <strong>Trustpilot</strong></span>';

    // Stop the parent click (review-scroll) from firing when user hits the trustpilot link
    link.addEventListener('click', function (e) { e.stopPropagation(); });

    rating.appendChild(link);
  }

  function run() {
    var ratings = document.querySelectorAll(HOST_SELECTOR);
    for (var i = 0; i < ratings.length; i++) {
      var r = ratings[i];
      hideCount(r);
      injectTrustpilot(r);
      makeClickable(r);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // MutationObserver in case Shopify editor reloads the block
  var debounceTimer = null;
  var observer = new MutationObserver(function () {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(run, 50);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
